import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const ChucksOtherTestTable: GenericTableSchemaInterface = {
  id: 'chucks-other-test-table',
  name: "Chuck's Other Test Table",
  description: 'This is a test table for Chuck',
  core: CoreType.STORAGE,
  mapping: {
    c01: {
      name: 'First Name',
      variable: VarKey.LocationHasCompletedQuickStart,
      defaultValue: '#*' + VarKey.LeaseBalance + '*# is really cool',
      isRequired: true
    },
    c02: {
      name: 'Favorite Food',
      defaultValue: 'Pizza'
    },
    c03: {
      name: 'Favorite Color'
    }
  }
}
